var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btnCta",class:_vm.data.fields.styleInstructions},[_c('rich-text-renderer',{attrs:{"data":_vm.data.fields.link}}),(_vm.data.fields.buttonActionType === 'JS-CLOSE' || _vm.data.fields.buttonActionType === 'JS-PRINT')?_c('rich-text-renderer',{attrs:{"data":_vm.data.fields.text}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }